module.exports={
    "over_size_message":"L'immagine che hai caricato supera i 10MB. Comprimeremo il tuo file per il caricamento. Fare clic su \"Conferma\" per continuare il caricamento.",
    "file_type_error":"Il file che hai caricato non è un'immagine! Prova a caricare di nuovo.",
    "upload_error":"Errore di caricamento! (Codice errore: 2000) Riprova.",
    "watermark_remove_over_size":"L'immagine che hai caricato supera i 5MB. Si consiglia di utilizzare il nostro compressore di immagini online gratuito. Fai clic per <a class=\"jump-link\" href=\"https://www.anymp4.com/it/image-compressor-online/\">ulteriori informazioni</a>",
    "watermark_remove_file_type_error":"Il file che hai caricato non è un'immagine, carica di nuovo.",
    "watermark_remove_image_type_error":"Il formato immagine non è supportato. Supportiamo solo JPG, JPEG, PNG e BMP.",
    "watermark_remove_upload_error":"Errore di riconoscimento (codice di errore: 2001), riprovare...",
    "watermark_remove_processing":"Elaborazione immagine in corso...",
    "watermark_remove_not_save":"L'area selezionata non verrà conservata. Sei sicuro di volerlo ritagliare?",
    "watermark_remove_back_home":"Lo stato attuale non verrà salvato. Sei sicuro di voler tornare a Home?",
    "watermark_remove_new_image":"Lo stato attuale non verrà salvato. Sei sicuro di voler scegliere una nuova immagine?",
    "watermark_select":"Selezionare",
    "watermark_select_area":"Seleziona l'area della filigrana che desideri cancellare prima di fare clic su Rimuovi.",
    "watermark_beyond_4k":"L'immagine selezionata supera la risoluzione di 4K. Siamo spiacenti di non poterlo elaborare al momento",
    "watermark_beyond_pixel_1":"La risoluzione dell'immagine selezionata supera <span>%spx</span><span>&times;%spx</span>. Non può essere elaborato, seleziona di nuovo.",
    "watermark_beyond_pixel_2":"I visitatori possono elaborare solo <span>%s</span> immagini con una risoluzione superiore a <span>%spx</span>x<span>%spx</span>, effettua il login e continua a utilizzare.",
    "watermark_beyond_size_1":"La dimensione dell'immagine selezionata supera <span>%sMB</span>. Non può essere elaborato, seleziona di nuovo.",
    "watermark_beyond_size_2":"La dimensione dell'immagine selezionata supera <span>%sMB</span>, ma i visitatori possono elaborare solo immagini inferiori a <span>%sMB</span>. Effettua il login e continua a utilizzare.",
    "no_user_down":"I visitatori possono scaricare solo <span>%s</span> immagini con qualità originale. Effettua il login e continua a scaricare. Inoltre, puoi conservare la cronologia di 7 giorni dopo l'accesso. Continua a scaricare immagini di larghezza o altezza <span>%spx</span>.",
    "no_down_rights":"Non è possibile scaricare immagini HD con qualità originale, aggiorna il tuo piano! Puoi anche continuare a scaricare immagini di bassa qualità con <span>%spx</span>.",
    "error_40001":"Errore: 40001. Contattaci",
    "error_40099":"Errore: 40099. Contattaci",
    "down_btn":"Il download è in preparazione, attendi un secondo...",
    "noRemove_down_btn":"Non hai fatto nulla per rimuovere le filigrane. Seleziona la filigrana che desideri rimuovere e fai clic sul pulsante Rimuovi. Quindi puoi scaricare la tua immagine.",
    "history_open":"Aprendo l'immagine modificata, attendere un momento...",
    "maskRightsMonitor_info":"La pagina per l'aggiornamento dei vantaggi è stata aperta in una nuova scheda e il tuo piano verrà sincronizzato automaticamente dopo l'aggiornamento.",
    "maskLoginMonitor_info":"La pagina di destinazione è stata aperta, completare il login su di essa. Dopo l'accesso o la registrazione con successo, questa pagina verrà sincronizzata automaticamente, non chiuderla.",
    "photo_rights_info":"<span><i class=\"num\">2</i> Immagini HD</span> con qualità originale possono essere scaricate al momento. <a href=\"https://account.anymp4.com\" target=\"_blank\">Visualizza dettagli>></a>",
    "rights_original":"Per attivare l'impostazione \"Utilizza la funzione Image Enhancer per ridurre la perdita di qualità\", devi aggiornare il tuo account!",
    "Brush":"Spazzola",
    "Lasso":"Lazo",
    "Polygonal":"Poligonale",
    "Eraser":"Gomma",
    "Free":"Libero",
    "More":"Di più:",
    "Select":"Selezionare",
    "Remove":"Rimuovere",
    "BrushSize":"Dimensione del pennello:",
    "AspectRatio":"Proporzioni:",
    "Upload":"Nuova foto",
    "History":"Storia",
    "Login":"Login",
    "MyAccount":"Il mio account",
    "Logout":"Disconnettersi",
    "Usinghelp":"Utilizzando l'aiuto>>",
    "Enhancer":"Utilizzare la funzione Image Enhancer per ridurre la perdita di qualità",
    "Download":"Scarica",
    "Guide":"Guida",
    "Polygonal1":"Poligonale",
    "Polygonal_info":"Fare clic con il pulsante sinistro del mouse per identificare un punto alla volta.",
    "Lasso1":"Lazo:",
    "Lasso_info":"Premere a lungo il pulsante sinistro del mouse per applicare il lazo all'area della filigrana.",
    "Brush1":"Spazzola:",
    "Brush_info":"Premere a lungo il pulsante sinistro del mouse per selezionare con precisione.",
    "Eraser1":"Gomma:",
    "Eraser_info":"Cancella le parti non necessarie dall'area selezionata.",
    "Click":"Clic",
    "the":"il",
    "click_info":"pulsante per iniziare a cancellare la filigrana indesiderata.",
    "PleaseUploadImages":"Si prega di caricare le immagini.",
    "CropInfo":"Una volta terminata la rimozione della filigrana, puoi fare clic sul pulsante Ritaglia per ritagliare l'immagine prima di salvarla, oppure fare clic sul pulsante Download per salvare direttamente l'immagine corrente.",
    "Crop":"Raccolto",
    "Back":"Di ritorno",
    "DownloadCropped":"Scarica Ritagliata",
    "Cancel":"Annulla",
    "FreeWatermarkRemover":"Rimozione filigrana gratuita",
    "Processing":"In lavorazione...",
    "NewImage":"Nuova immagine",
    "Retry":"Riprova",
    "Yes":"Sì",
    "No":"No",
    "FailureFeedback":"Feedback sul fallimento",
    "removeTip":"Dopo aver selezionato l'area della filigrana, fare clic su Rimuovi per cancellare la filigrana.",
    "rightDown":"Scarica immagini di bassa qualità",
    "history_will":"Scadrà dopo",
    "Expired":"(È scaduto)",
	"uploadImage":"Carica immagine",
    "uploadImageInfo":"Oppure trascina qui il tuo file immagine per rimuovere la filigrana!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Illimitato",
    "watermark_beyond_pixel_3":"L'immagine selezionata supera la <span>%s&times;%s risoluzione</span>, aggiorna prima il tuo piano.",
    "watermark_beyond_size_3":"L'immagine selezionata supera <span>%sMB</span>, aggiorna prima il tuo piano.",
    "no_user_login":"I nuovi utenti che effettuano l'accesso possono ottenere DUE vantaggi per il download di immagini originali HD.<span class=\"loginMaskbtn\">Accedi immediatamente>></span>",
    "Upgrade":"Aggiornamento",
    "Loading":"Caricamento in corso…",
    "SelectAll":"Seleziona tutto",
    "Open":"Aprire",
    "Delete":"Elimina",
    "Clear":"Cancella non valido",
    "noHistory":"Nessuna storia",
    "Close":"Vicino",
    "buyUserInfo":"ongratulazioni! Hai eseguito l'upgrade con successo. Si prega di tornare alla home page e utilizzare questo prodotto.",
    "buyNoUserInfo":"Congratulazioni! Hai eseguito l'upgrade con successo. I vantaggi sono stati vincolati all'indirizzo e-mail che hai lasciato durante l'aggiornamento. Utilizza l'account registrato o collegato all'indirizzo e-mail per <span class=\"loginMaskbtn\">accedere per usufruire dei vantaggi</span>. Se non hai registrato o collegato un account con l'indirizzo e-mail, <span class=\"registerMaskbtn\">usa l'indirizzo e-mail per registrare un account</span> o collega altri account a questo indirizzo e-mail indirizzo di posta per l'utilizzo dei benefici.",
    "GetStarted":"Iniziare",
    "AccessTo":"Accesso a:",
    "imagesOfwatermarkremoval":"immagini di rimozione della filigrana",
    "upTo":"Fino a",
    "perImage":"per immagine",
    "Support":"Supporto",
    "resolution":"risoluzione",
    "PrepaidPackage":"Pacchetto prepagato",
    "PayasYouGo":"Paga mentre vai",
    "TaxIncl":"Tasse incluse.",
    "Checkout":"Guardare",
    "imagesDay":"immagini/giorno",
    "imagesMonthly":"immagini/mensile",
    "image":"Immagine",
    "images":"immagini",
    "imageSize":"dimensione dell'immagine",
    "buyInfo1":"Integrazioni di <span>enhancer</span> di terze parti",
    "buyInfo2":"La cronologia delle modifiche è valida per 7 giorni",
    "buyInfo3":"Elaborazione prioritaria",
    "buyInfo4":"Assistenza clienti 7x24",
    "buyInfo5":"Scaduto dopo 24 ore",
    "buyInfo6":"Nessun abbonamento. Nessun rinnovo automatico!",
    "buyInfo7":"Disponibile per l'uso in qualsiasi momento per sempre",
    "dayPlan":"Piano di 1 giorno",
    "Lifetime":"Tutta la vita",
    "note":"<span>Nota</span>: si prega di notare che il piano acquistato è legato all'indirizzo e-mail fornito durante il checkout. Per utilizzare il piano con successo, registrarsi o accedere con lo stesso indirizzo e-mail."
}